import { apiFetch } from './atlas';

/**
 * Publish an itinerary. Runs the backend's structural + content moderation
 * gate before it goes public — throws with a user-facing message if blocked.
 */
export async function publishItinerary(itineraryId) {
  const { data } = await apiFetch(`/api/itineraries/${itineraryId}/publish`, {
    method: 'POST',
  });
  return data;
}
